<div class="shell-wrapper">
  <div class="flex items-center space-x-2 ml-2 mt-2">
    <ng-icon name="heroCommandLine" size="18" />
    <span class="terminal-heading-text">Terminal</span>
  </div>
  <ng-terminal #term class="terminal-instance"></ng-terminal>
</div>